import Award from "@/components/Award"
import Sitemap from "@/components/Sitemap"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getRegionConfig } from "@/lib/regionConfig"

export const AppFooter =()=>{
    const region = getRegionConfig();
    return<>
    <div className="bg-[#f7f7f7] md:px-32 px-4 pt-2 pb-12">
        <div className="grid md:grid-cols-3 gap-6 my-12">
          <div className="bg-white py-8 px-6 rounded-sm drop-shadow-sm flex flex-col space-y-2">
            <div className="font-bold text-2xl mb-2">About your booking</div>
         <a className="hover:underline cursor-pointer text-sm flex flex-row items-center" href="/search-booking">
              Manage your booking
              <FontAwesomeIcon
                icon={faArrowRight}
                className="text-gray-400 ml-2"
              />
            </a>
          </div>
          <div className="bg-white py-8 px-6 rounded-sm drop-shadow-sm flex flex-col space-y-2">
            <div className="font-bold text-2xl mb-2">Exclusive offers</div>
            <div className="text-gray-600">
              Sign up to our newsletter to receive our latest offers
            </div>
            <span className="bg-yellow-300 self-end py-4 px-5 rounded-md">
              <a href="https://pub.europcar-infos.com/Newsletter?&code=com&lang=en&dev=false" target="_blank"><FontAwesomeIcon icon={faArrowRight} className="fa-xl" /></a>
            </span>
          </div>
          <div className="bg-white py-8 px-6 rounded-sm drop-shadow-sm flex flex-col justify-between">
            <div className="flex flex-col">
              <div className="font-bold text-2xl mb-2">
                Same smart app. More mobility.
              </div>
              <a href={`${region.productionUrl}/pages/mobile-app`} className="hover:underline cursor-pointer text-sm text-green-600 font-bold md:my-0 mb-4 mt-2">
                For more information
              </a>
            </div>
            <div className="flex flex-row space-x-2">
              <a href="https://play.google.com/store/apps/details?id=com.clanmo.europcar"><img src="/app/google-play.svg" /></a>
              <a href="https://apps.apple.com/us/app/europcar-car-and-van-rentals/id377889715"><img src="/app/app-store.svg" /></a>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-4 gap-2">
          <Sitemap
            title="More Information"
            contentList={[
              {
                title: "Contact us",
                url: `${region.productionUrl}/pages/contact-us`,
              },
              {
                title: "Europcar on mobile",
                url: `${region.productionUrl}/pages/mobile-app`,
              },
              {
                title: "Find a rental location",
                url: `${region.productionUrl}/pages/our-locations`,
              },
            ]}
          />
          <Sitemap
            title="Business Center"
            contentList={[
              {
                title: "Corporate account",
                url: `${region.productionUrl}/pages/corporate-car-leasing`,
              },
              {
                title: "Business solutions",
                url: `${region.productionUrl}/pages/corporate-car-leasing`,
              },
              {
                title: "Tour operators",
                url: `${region.productionUrl}/pages/tour-operator`,
              },
              {
                title: "Travel agents",
                url: `${region.productionUrl}/pages/travel-agents`,
              },
            ]}
          />
          <Sitemap
            title="Europcar Mobility Group"
            contentList={[
              {
                title: "Careers",
                url: "https://www.linkedin.com/company/europcar",
              },
              {
                title: "Goldcar",
                url: "https://www.goldcar.es/en/",
              },
              {
                title: "Europcar On Demand",
                url: "https://welcome.ubeeqo.com/global/carsharing-by-europcar/",
              },
              {
                title: "FOX Rent A Car",
                url: "https://www.foxrentacar.com/en.html",
              },
            ]}
          />
          <Sitemap
            title="Legal Information"
            contentList={[
              {
                title: "Legal Information",
                url: `${region.productionUrl}/pages/legal-information`,
              },
              {
                title: "Damage Management Policy",
                url: `${region.productionUrl}/pages/damage-policy`,
              },
              {
                title: "Deposit & Cancellation Policy",
                url: `${region.productionUrl}/pages/deposit-policy`,
              },
              {
                title: "Security and Privacy Policy",
                url: `${region.productionUrl}/pages/pdpa`,
              },
              {
                title: "Terms and conditions",
                url:`${region.productionUrl}/pages/terms-conditions`,
              },
            ]}
          />
        </div>
      </div>
      <Award />
      {/* Footer */}
      <div className="bg-black grid md:grid-cols-8 md:px-32 px-4 text-sm">
        <span className="text-gray-400 py-8">@ Europcar {new Date().getFullYear()}</span>
        <div className="col-span-6 md:flex md:flex-row space-x-2 divide-x divide-white text-white font-bold justify-start py-8">
          <span className="cursor-pointer"><a href="#">Site Map</a></span>
          <span className="pl-2 cursor-pointer"><a href={`${region.productionUrl}/pages/legal-information`}>Legal Information</a></span>
          <span className="pl-2 cursor-pointer">
            <a href={`${region.productionUrl}/pages/pdpa`}>Cookies, Security and Privacy Policy</a>
          </span>
          <span className="pl-2 cursor-pointer"><a href={`${region.productionUrl}/pages/contact-us`}>Contact Us</a></span>
        </div>
        <div className="flex flex-row items-center gap-2 py-2">
          <a href="https://www.europcar.com/editorial/en" target="_blank"><img src="/small-logo-white.svg" className="w-[45px] h-[45px]" /></a>
          <a href="https://www.linkedin.com/company/europcar" target="_blank"><img src="/icon/linkedin.svg" className="w-[45px] h-[45px]" /></a>
        </div>
      </div>
    </>
}
